import { createContext, useContext, useEffect, useState } from 'react';
import { getData } from '../services/api';
import { API_ENDPOINTS } from '../constant/API_ENDPOINTS';

const InitialFetchContext = createContext();

export const InitialFetchProvider = ({ children }) => {
    const [storeInformation, setStoreInformation] = useState(null);
    const [homeProducts, setHomeProducts] = useState(null);
    const [homeMainCategories, setHomeMainCategories] = useState(null);
    const [homeBanners, setHomeBanners] = useState(null);
    const [projectDataEnteprise, setProjectDataEnteprise] = useState(null);
    const [projectDataPersonal, setProjectDataPersonal] = useState(null);
    const [svgContent, setSvgContent] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                const [
                    storeInfoResponse,
                    homeProductsResponse,
                    homeMainCategoriesResponse,
                    homeBannersResponse,
                    projectDataEntepriseResponse,
                    projectDataPersonalResponse 
                ] = await Promise.allSettled([
                    getData(API_ENDPOINTS.STORE_INFORMATION + "/1"),
                    getData(API_ENDPOINTS.HOME_PRODUCTS),
                    getData(API_ENDPOINTS.HOME_MAIN_CATEGORIES),
                    getData(API_ENDPOINTS.HOME_BANNERS),
                    getData(API_ENDPOINTS.PROJECTS + "?filters[project_scale]=empresarial"),
                    getData(API_ENDPOINTS.PROJECTS + "?filters[project_scale]=persona_natural")
                ]);

                if (storeInfoResponse.status === 'fulfilled') {
                    const formattedStoreInfo = {
                        ...storeInfoResponse.value.data,
                    };
                    setStoreInformation(formattedStoreInfo);
                }
                if (homeProductsResponse.status === 'fulfilled') setHomeProducts(homeProductsResponse.value.data);
                if (homeMainCategoriesResponse.status === 'fulfilled') setHomeMainCategories(homeMainCategoriesResponse.value.data);
                if (homeBannersResponse.status === 'fulfilled') setHomeBanners(homeBannersResponse.value.data);
                if (projectDataEntepriseResponse.status === 'fulfilled') setProjectDataEnteprise(projectDataEntepriseResponse.value.data);
                if (projectDataPersonalResponse.status === 'fulfilled') setProjectDataPersonal(projectDataPersonalResponse.value.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        const fetchSVG = async (url) => {
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error('Network response was not ok');
                const data = await res.text();
                setSvgContent(data);
            } catch (error) {
                console.error('Fetch SVG failed:', error);
            }
        };

        fetchInitialData();
        fetchSVG('/assets/img/logo.svg').catch(() => fetchSVG('/logo.svg'));
    }, []);

    return (
        <InitialFetchContext.Provider value={{
            storeInformation,
            homeProducts,
            homeMainCategories,
            homeBanners,
            projectDataEnteprise,
            projectDataPersonal,
            svgContent,
            loading,
            error
        }}>
            {children}
        </InitialFetchContext.Provider>
    );
};

export const useInitialFetch = () => useContext(InitialFetchContext);
